import React from 'react'
import Layout from '@/layouts/MainLayout'
import SEO from '@/components/seo'
import { navigate } from 'gatsby'
import { useQuery } from 'react-query'
import { getNewsItemQuery } from '../api/news'
import { NewsPage } from '../components/NewsPage/NewsPage'

const News = ({ params }) => {
  const { data } = useQuery(
    ['news', params],
    () => getNewsItemQuery(params['*']),
    {
      onError: () => navigate('/404'),
    }
  )
  return (
    <Layout>
      <SEO title={data?.theme} />
      <NewsPage data={data} />
    </Layout>
  )
}

export default News
